import { render, staticRenderFns } from "./MultipleChoiceMultipleAnswers.vue?vue&type=template&id=19ceb002&scoped=true&"
import script from "./MultipleChoiceMultipleAnswers.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceMultipleAnswers.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceMultipleAnswers.vue?vue&type=style&index=0&id=19ceb002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ceb002",
  null
  
)

export default component.exports